import { AbstractInteractors } from './AbstractInteractors';
import { UnGroup } from './../cmd/GroupUngroupElements';
import { InteractorType } from '@egr/wcf/modules/core/tool';
export class GroupElementInteractors extends AbstractInteractors {
    constructor(pRoomManager, pGroup) {
        super(pRoomManager);
        this.mGroup = pGroup;
        this.mLockInteractor = null;
    }
    showInteractors(pShow) {
        this.clear();
        if (!pShow || this.mApp.model.selection.length !== 1)
            return;
        this.mInteractorManager.enabled = true;
        // positioning: upper right corner
        let tBB = this.mGroup.boundingBox;
        let tWM = this.mGroup.node.getWorldMatrix();
        let tWP = tBB.getPoints(tWM);
        let tPmin = tWP[0];
        let tPmax = tWP[5];
        let toffDir = (tPmax.subtract(tPmin)).normalize();
        // lock / unlock
        let tInteractor = this.createInteractor("ungroup-interactor", tPmax, toffDir, 20, undefined, false, true);
        tInteractor.type = InteractorType.Button;
        tInteractor.onTriggerAction = () => this.ungroup();
    }
    clear() {
        this.mInteractorManager.clear();
        if (this.mLockInteractor != null)
            this.mInteractorManager.removeInteractor(this.mLockInteractor);
    }
    _mouseEnter(pRoomManager, pSpanElement) {
        let tStyle = pSpanElement.style;
        tStyle.color = pRoomManager.app.theme.mainColorBright;
    }
    _mouseLeave(pRoomManager, pSpanElement) {
        let tStyle = pSpanElement.style;
        tStyle.color = "#4f4f4f";
    }
    ungroup() {
        let tCmd = new UnGroup(this.mRoomManager, [this.mGroup]);
        if (tCmd.isAvailable()) {
            this.mApp.commands.executeCommand(tCmd);
            let tChilds = tCmd.UnGroupChilds;
            this.mApp.model.setSelection(tChilds);
        }
    }
}
